

































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Typography } from '@/components/atoms';
import CheckIcon from '@/components/icons/Check.vue';

@Component({
  components: {
    Typography,
    CheckIcon
  }
})
export default class Checkpoint extends Vue {
  @Prop({ default: '' }) title!: string;
  @Prop({ default: () => [] }) items!: string[];
}
